(() => {
  angular
    .module('finance')
    .controller(
      'finance.views.debugTools.syncCitibankStatementModal',
      SyncCitibankStatementModalController
    );

  SyncCitibankStatementModalController.$inject = [
    '$uibModalInstance',
    'abp.services.finance.debugTools',
    'moment',
  ];

  function SyncCitibankStatementModalController($uibModalInstance, debugToolsSvc, moment) {
    const vm = this;

    vm.saving = 0;

    // The run date determines the statement range. Citibank does not serve a statement for the
    // current day, so a run covers the three days ending the day before its own date, and a run
    // date later than today has nothing valid to ask for.

    vm.runDate = moment().startOf('day');
    vm.maxDate = moment().startOf('day');

    vm.syncCitibankStatement = syncCitibankStatement;
    vm.cancel = cancel;

    function syncCitibankStatement() {
      vm.saving += 1;
      debugToolsSvc
        .syncCitibankStatement({
          // Format locally rather than sending the moment itself, which would serialise to UTC
          // and shift the date a day back for Malaysian users.
          runDate: vm.runDate.format('YYYY-MM-DD'),
        })
        .success(() => {
          abp.notify.success(App.localize('SuccessfullyScheduled'));
        })
        .finally(() => {
          $uibModalInstance.close();
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
